/* @flow */
import { combineReducers } from 'redux-immutable';
import { OrderedMap, fromJS, List, Map } from 'immutable';

import type { Action } from 'trustar/utils/redux-types.js';

import {
  FETCH_METADATA,
  FETCH_METADATA_SUCCESS,
  FETCH_METADATA_FAILURE,
} from '../reports/action-types';

import {
  FETCH_TRIAGE_REPORTS,
  FETCH_TRIAGE_REPORTS_AND_ENRICH,
  FETCH_TRIAGE_REPORTS_SUCCESS,
  FETCH_TRIAGE_REPORTS_FAILURE,
  SET_TRIAGE_STATUS_FOR_REPORT,
  SET_TRIAGE_STATUS_FOR_REPORT_SUCCESS,
  SET_TRIAGE_STATUS_FOR_REPORT_FAILURE,
  RESET_PAGE,
} from './action-types';
import {defaultTriageRequestPayload, initialTriageSubmissionsState} from './getters';

// TODO Add Default for triage submissions object
const triageSubmissions = (state: Map<string, any> = initialTriageSubmissionsState, action: Action<*>) => {
  const { type, payload } = action;

  switch(type) {
  case FETCH_TRIAGE_REPORTS_SUCCESS:
    return fromJS(payload);
  case SET_TRIAGE_STATUS_FOR_REPORT_SUCCESS:
    // TODO Streamline
    const triageReports = state.get('items');
    const updatedReports = triageReports
      .filter(r => r.get('submissionId') !== payload.submissionId)
    return state.set('items', updatedReports);
  default:
    return state;
  }
};

const isSetTriageStatusInProgress = (state: boolean = false, action: Action<string>) => {
  const { type } = action;

  switch(type) {
  case SET_TRIAGE_STATUS_FOR_REPORT:
    return true;
  case SET_TRIAGE_STATUS_FOR_REPORT_SUCCESS:
  case SET_TRIAGE_STATUS_FOR_REPORT_FAILURE:
    return false;
  default:
    return state;
  }
};
const isFetchTriageReportsInProgress = (state: boolean = true, action: Action<string>) => {
  const { type } = action;

  switch(type) {
  case FETCH_TRIAGE_REPORTS:
  case FETCH_TRIAGE_REPORTS_AND_ENRICH:
  case FETCH_METADATA:
    return true;
  case FETCH_TRIAGE_REPORTS_SUCCESS:
  case FETCH_TRIAGE_REPORTS_FAILURE:
  case FETCH_METADATA_SUCCESS:
  case FETCH_METADATA_FAILURE:
    return false;
  default:
    return state;
  }
};

// TODO Create types for payload
const currentTriageQuery = (state: Map<string, any> = defaultTriageRequestPayload, action: Action<string>) => {
  const { type, payload } = action;

  switch(type) {
  case RESET_PAGE:
    return defaultTriageRequestPayload;
  case FETCH_TRIAGE_REPORTS:
  case FETCH_TRIAGE_REPORTS_AND_ENRICH:
    return payload;
  default:
    return state;
  }
};

const loadingMessage = (state: string = '', action: Action<*>) => {
  const { type } = action;

  switch (type) {
    case FETCH_TRIAGE_REPORTS_AND_ENRICH:
      return 'Fetching phishing reports';
    case FETCH_METADATA:
      return 'Populating reports metadata';
    case FETCH_TRIAGE_REPORTS_SUCCESS:
    case FETCH_TRIAGE_REPORTS_FAILURE:
    case FETCH_METADATA_SUCCESS:
    case FETCH_METADATA_FAILURE:
      return '';
    default:
      return state;
  }
};

export default combineReducers({
  isSetTriageStatusInProgress,
  isFetchTriageReportsInProgress,
  triageSubmissions,
  currentTriageQuery,
  loadingMessage,
});



// WEBPACK FOOTER //
// ./src/app/modules/triage/stores.js